import { Modal, Button } from "react-bootstrap";

function EliminarModuloModal({ show, onClose, onConfirm, nombreModulo }) {
  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirmar eliminación</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        ¿Estás seguro que deseas eliminar el módulo <strong>{nombreModulo}</strong>?
        <br />
        <span className="text-danger">Esta acción no se puede deshacer.</span>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancelar
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Sí, eliminar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EliminarModuloModal;
